/**
 * A fill style for a canvas context.
 *
 * @category Theme
 */
export type FillStyle = string | CanvasGradient | CanvasPattern;